var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiTank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 93,
    viewBox: "0 0 114 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9091 15.5H77.7273V10.3333C77.7273 4.65 73.0636 0 67.3636 0H46.6364C40.9364 0 36.2727 4.65 36.2727 10.3333V15.5H31.0909C13.9391 15.5 0 29.3983 0 46.5C0 63.6017 13.9391 77.5 31.0909 77.5V93H41.4545V77.5H72.5455V93H82.9091V77.5C100.061 77.5 114 63.6017 114 46.5C114 29.3983 100.061 15.5 82.9091 15.5ZM46.6364 10.3333H67.3636V15.5H46.6364V10.3333ZM82.9091 67.1667H31.0909C19.6391 67.1667 10.3636 57.9183 10.3636 46.5C10.3636 35.0817 19.6391 25.8333 31.0909 25.8333H82.9091C94.3609 25.8333 103.636 35.0817 103.636 46.5C103.636 57.9183 94.3609 67.1667 82.9091 67.1667Z",
    fill: "#0C85C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiTank);
export default __webpack_public_path__ + "static/media/MITank.beba2236b3833962f94b8eda242592eb.svg";
export { ForwardRef as ReactComponent };